import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MEGA_AUTH_STORAGE_KEY } from '../constants/auth-session.constants';
import { MegacableAuthService } from './megacable-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthSessionService {

  private readonly _sessionChange$ = new BehaviorSubject<void>(undefined);

  readonly sessionChange$ = this._sessionChange$.asObservable();

  constructor(private readonly megacableAuth: MegacableAuthService) {
    this.megacableAuth.sessionChange$.subscribe(() => {
      this._sessionChange$.next();
    });
  }

  isAuthenticated(): boolean {
    if (this.megacableAuth.isAuthenticated()) {
      return true;
    }

    try {
      const raw = localStorage.getItem(MEGA_AUTH_STORAGE_KEY);
      return !!raw && raw !== 'null' && raw !== '{}';
    } catch {
      return false;
    }
  }

  canAddToCart(): boolean {
    return this.isAuthenticated();
  }

  /** Para integración futura con API de login. */
  setAuthenticatedUser(user: unknown): void {
    try {
      localStorage.setItem(MEGA_AUTH_STORAGE_KEY, JSON.stringify(user));
    } catch {
      /* ignore */
    }
    this._sessionChange$.next();
  }

  clearSession(): void {
    this.megacableAuth.clearSession();
    try {
      localStorage.removeItem(MEGA_AUTH_STORAGE_KEY);
      sessionStorage.removeItem('mega_cart_guest');
    } catch {
      /* ignore */
    }
    this._sessionChange$.next();
  }
}
